<template>
    <ies-form-field :field="field">
        <v-radio-group
            v-model="viewValue"
            row
            autocomplete >
            <v-radio label="Day Visit"   :value="0" ></v-radio>
            <v-radio label="Overnight"   :value="1" ></v-radio>
        </v-radio-group>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Allows the setting of the visit type via a radio button group
     */
    export default {
        name: 'ies-input-visit-type',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                viewValue: parseInt(this.field.value),
            }
        },

        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>


